// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file reports/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { PaymentMode } from "../sales/common_pb.js";
import { ItemType } from "../inventory/common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ComparisionItem
 */
export class ComparisionItem extends Message<ComparisionItem> {
  /**
   * Value for the current period
   *
   * @generated from field: float request_period_value = 1;
   */
  requestPeriodValue = 0;

  /**
   * Value for the previous period
   *
   * @generated from field: float previous_period_value = 2;
   */
  previousPeriodValue = 0;

  /**
   * Percentage change between the two periods
   *
   * @generated from field: float percentage_change = 3;
   */
  percentageChange = 0;

  constructor(data?: PartialMessage<ComparisionItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ComparisionItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "request_period_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "previous_period_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "percentage_change", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ComparisionItem {
    return new ComparisionItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ComparisionItem {
    return new ComparisionItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ComparisionItem {
    return new ComparisionItem().fromJsonString(jsonString, options);
  }

  static equals(a: ComparisionItem | PlainMessage<ComparisionItem> | undefined, b: ComparisionItem | PlainMessage<ComparisionItem> | undefined): boolean {
    return proto3.util.equals(ComparisionItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ComparisionItemWithPaymentMode
 */
export class ComparisionItemWithPaymentMode extends Message<ComparisionItemWithPaymentMode> {
  /**
   * Payment mode (e.g., cash, card, etc.)
   *
   * @generated from field: com.neulink.pharmacy.PaymentMode payment_mode = 1;
   */
  paymentMode = PaymentMode.UNKNOWN;

  /**
   * Comparison item containing values for the payment mode
   *
   * @generated from field: com.neulink.pharmacy.ComparisionItem comparision_item = 2;
   */
  comparisionItem?: ComparisionItem;

  constructor(data?: PartialMessage<ComparisionItemWithPaymentMode>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ComparisionItemWithPaymentMode";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_mode", kind: "enum", T: proto3.getEnumType(PaymentMode) },
    { no: 2, name: "comparision_item", kind: "message", T: ComparisionItem },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ComparisionItemWithPaymentMode {
    return new ComparisionItemWithPaymentMode().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ComparisionItemWithPaymentMode {
    return new ComparisionItemWithPaymentMode().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ComparisionItemWithPaymentMode {
    return new ComparisionItemWithPaymentMode().fromJsonString(jsonString, options);
  }

  static equals(a: ComparisionItemWithPaymentMode | PlainMessage<ComparisionItemWithPaymentMode> | undefined, b: ComparisionItemWithPaymentMode | PlainMessage<ComparisionItemWithPaymentMode> | undefined): boolean {
    return proto3.util.equals(ComparisionItemWithPaymentMode, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SalesCountByDate
 */
export class SalesCountByDate extends Message<SalesCountByDate> {
  /**
   * Date in timestamp format
   *
   * @generated from field: int32 date = 1;
   */
  date = 0;

  /**
   * Number of sales on that date
   *
   * @generated from field: int32 sales_count = 2;
   */
  salesCount = 0;

  constructor(data?: PartialMessage<SalesCountByDate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SalesCountByDate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sales_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SalesCountByDate {
    return new SalesCountByDate().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SalesCountByDate {
    return new SalesCountByDate().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SalesCountByDate {
    return new SalesCountByDate().fromJsonString(jsonString, options);
  }

  static equals(a: SalesCountByDate | PlainMessage<SalesCountByDate> | undefined, b: SalesCountByDate | PlainMessage<SalesCountByDate> | undefined): boolean {
    return proto3.util.equals(SalesCountByDate, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PLReportItem
 */
export class PLReportItem extends Message<PLReportItem> {
  /**
   * Receipt number for the item
   *
   * @generated from field: string receipt_number = 1;
   */
  receiptNumber = "";

  /**
   * Date of the item
   *
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * Name of the patient
   *
   * @generated from field: string patient_name = 3;
   */
  patientName = "";

  /**
   * Invoice amount before tax
   *
   * @generated from field: float invoice_amount_before_tax = 4;
   */
  invoiceAmountBeforeTax = 0;

  /**
   * Grand total amount including tax
   *
   * @generated from field: float grand_total_with_tax = 5;
   */
  grandTotalWithTax = 0;

  /**
   * Total tax amount
   *
   * @generated from field: float total_tax = 6;
   */
  totalTax = 0;

  /**
   * Total discount applied
   *
   * @generated from field: float total_discount = 7;
   */
  totalDiscount = 0;

  /**
   * Total cost of goods sold
   *
   * @generated from field: float total_cogs = 8;
   */
  totalCogs = 0;

  /**
   * Gross profit calculated as (grand total - total COGS)
   *
   * @generated from field: float gross_profit = 9;
   */
  grossProfit = 0;

  constructor(data?: PartialMessage<PLReportItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PLReportItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "receipt_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_at", kind: "message", T: Timestamp },
    { no: 3, name: "patient_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "invoice_amount_before_tax", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "grand_total_with_tax", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "total_tax", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "total_discount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "total_cogs", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "gross_profit", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PLReportItem {
    return new PLReportItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PLReportItem {
    return new PLReportItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PLReportItem {
    return new PLReportItem().fromJsonString(jsonString, options);
  }

  static equals(a: PLReportItem | PlainMessage<PLReportItem> | undefined, b: PLReportItem | PlainMessage<PLReportItem> | undefined): boolean {
    return proto3.util.equals(PLReportItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SupplierProfitabilityItem
 */
export class SupplierProfitabilityItem extends Message<SupplierProfitabilityItem> {
  /**
   * Unique identifier for the supplier
   *
   * @generated from field: string supplier_id = 1;
   */
  supplierId = "";

  /**
   * Name of the supplier
   *
   * @generated from field: string supplier_name = 2;
   */
  supplierName = "";

  /**
   * Total cost of goods purchased from the supplier
   *
   * @generated from field: float total_cost_of_goods_purchased = 3;
   */
  totalCostOfGoodsPurchased = 0;

  /**
   * Total revenue generated from sales of goods purchased from the supplier
   *
   * @generated from field: float total_revenue_generated = 4;
   */
  totalRevenueGenerated = 0;

  /**
   * Gross profit calculated as (total revenue - total cost of goods)
   *
   * @generated from field: float gross_profit = 5;
   */
  grossProfit = 0;

  /**
   * Gross margin percentage calculated as (gross profit / total revenue) * 100
   *
   * @generated from field: float gross_margin_percentage = 6;
   */
  grossMarginPercentage = 0;

  /**
   * Total number of units purchased from the supplier
   *
   * @generated from field: float total_units_purchased = 7;
   */
  totalUnitsPurchased = 0;

  /**
   * Total number of units sold from the supplier
   *
   * @generated from field: float total_units_sold = 8;
   */
  totalUnitsSold = 0;

  /**
   * Sell-through rate percentage calculated as (total units sold / total units purchased) * 100
   *
   * @generated from field: float sell_through_rate_percentage = 9;
   */
  sellThroughRatePercentage = 0;

  /**
   * Current stock value at cost for the supplier
   *
   * @generated from field: float current_stock_value_at_cost = 10;
   */
  currentStockValueAtCost = 0;

  constructor(data?: PartialMessage<SupplierProfitabilityItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SupplierProfitabilityItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "supplier_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_cost_of_goods_purchased", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "total_revenue_generated", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "gross_profit", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "gross_margin_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "total_units_purchased", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "total_units_sold", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "sell_through_rate_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "current_stock_value_at_cost", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupplierProfitabilityItem {
    return new SupplierProfitabilityItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupplierProfitabilityItem {
    return new SupplierProfitabilityItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupplierProfitabilityItem {
    return new SupplierProfitabilityItem().fromJsonString(jsonString, options);
  }

  static equals(a: SupplierProfitabilityItem | PlainMessage<SupplierProfitabilityItem> | undefined, b: SupplierProfitabilityItem | PlainMessage<SupplierProfitabilityItem> | undefined): boolean {
    return proto3.util.equals(SupplierProfitabilityItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ProductProfitabilityItem
 */
export class ProductProfitabilityItem extends Message<ProductProfitabilityItem> {
  /**
   * Unique identifier for the product master
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * Trade name of the product
   *
   * @generated from field: string trade_name = 2;
   */
  tradeName = "";

  /**
   * Total quantity of the product sold
   *
   * @generated from field: float total_quantity_sold = 3;
   */
  totalQuantitySold = 0;

  /**
   * Total revenue generated from sales of the product
   *
   * @generated from field: float total_revenue = 4;
   */
  totalRevenue = 0;

  /**
   * Total cost of goods sold for
   *
   * @generated from field: float total_cost_of_goods_sold = 5;
   */
  totalCostOfGoodsSold = 0;

  /**
   * Gross profit calculated as (total revenue - total cost of goods sold)
   *
   * @generated from field: float gross_profit = 6;
   */
  grossProfit = 0;

  /**
   * Gross margin percentage calculated as (gross profit / total revenue) * 100
   *
   * @generated from field: float gross_margin_percentage = 7;
   */
  grossMarginPercentage = 0;

  /**
   * Average selling price of the product
   *
   * @generated from field: float average_selling_price = 8;
   */
  averageSellingPrice = 0;

  /**
   * Average discount applied per unit of the product
   *
   * @generated from field: float average_discount_per_unit = 9;
   */
  averageDiscountPerUnit = 0;

  /**
   * Unit of measurement for the product (e.g., pieces, grams, etc.)
   *
   * @generated from field: int32 unit = 10;
   */
  unit = 0;

  /**
   * Type of unit for the product (e.g., piece, kg, etc.)
   *
   * @generated from field: string unit_type = 11;
   */
  unitType = "";

  /**
   * Type of item (e.g., medical, non-medical)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 12;
   */
  itemType = ItemType.UNSPECIFIED;

  constructor(data?: PartialMessage<ProductProfitabilityItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ProductProfitabilityItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_quantity_sold", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "total_revenue", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "total_cost_of_goods_sold", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "gross_profit", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "gross_margin_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "average_selling_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "average_discount_per_unit", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProductProfitabilityItem {
    return new ProductProfitabilityItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProductProfitabilityItem {
    return new ProductProfitabilityItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProductProfitabilityItem {
    return new ProductProfitabilityItem().fromJsonString(jsonString, options);
  }

  static equals(a: ProductProfitabilityItem | PlainMessage<ProductProfitabilityItem> | undefined, b: ProductProfitabilityItem | PlainMessage<ProductProfitabilityItem> | undefined): boolean {
    return proto3.util.equals(ProductProfitabilityItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CustomerProfitabilityItem
 */
export class CustomerProfitabilityItem extends Message<CustomerProfitabilityItem> {
  /**
   * Unique identifier for the customer
   *
   * @generated from field: string custoemr_id = 1;
   */
  custoemrId = "";

  /**
   * Name of the customer
   *
   * @generated from field: string customer_name = 2;
   */
  customerName = "";

  /**
   * Phone number of the customer
   *
   * @generated from field: string customer_phone = 3;
   */
  customerPhone = "";

  /**
   * Status of the customer (e.g., active, inactive)
   *
   * @generated from field: string customer_status = 4;
   */
  customerStatus = "";

  /**
   * Number of visits made by the customer
   *
   * @generated from field: int32 number_of_vists = 5;
   */
  numberOfVists = 0;

  /**
   * Date of the last visit made by the customer
   *
   * @generated from field: google.protobuf.Timestamp last_visit_date = 6;
   */
  lastVisitDate?: Timestamp;

  /**
   * Total revenue generated from the customer over their lifetime
   *
   * @generated from field: float lifetime_revenue = 7;
   */
  lifetimeRevenue = 0;

  /**
   * Total refunds issued to the customer
   *
   * @generated from field: float total_refunds = 8;
   */
  totalRefunds = 0;

  /**
   * Net revenue calculated as (lifetime revenue - total refunds)
   *
   * @generated from field: float net_revenue = 9;
   */
  netRevenue = 0;

  /**
   * Total cost of goods sold for the customer
   *
   * @generated from field: float total_cogs = 10;
   */
  totalCogs = 0;

  /**
   * Gross profit calculated as (net revenue - total COGS)
   *
   * @generated from field: float gross_profit = 11;
   */
  grossProfit = 0;

  /**
   * Gross margin percentage calculated as (gross profit / net revenue) * 100
   *
   * @generated from field: float gross_margin_percentage = 12;
   */
  grossMarginPercentage = 0;

  /**
   * Average basket value calculated as (net revenue / number of visits)
   *
   * @generated from field: float average_basket_value = 13;
   */
  averageBasketValue = 0;

  constructor(data?: PartialMessage<CustomerProfitabilityItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CustomerProfitabilityItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "custoemr_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "customer_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "customer_phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "customer_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "number_of_vists", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "last_visit_date", kind: "message", T: Timestamp },
    { no: 7, name: "lifetime_revenue", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "total_refunds", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "net_revenue", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "total_cogs", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 11, name: "gross_profit", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 12, name: "gross_margin_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 13, name: "average_basket_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CustomerProfitabilityItem {
    return new CustomerProfitabilityItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CustomerProfitabilityItem {
    return new CustomerProfitabilityItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CustomerProfitabilityItem {
    return new CustomerProfitabilityItem().fromJsonString(jsonString, options);
  }

  static equals(a: CustomerProfitabilityItem | PlainMessage<CustomerProfitabilityItem> | undefined, b: CustomerProfitabilityItem | PlainMessage<CustomerProfitabilityItem> | undefined): boolean {
    return proto3.util.equals(CustomerProfitabilityItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SalesPerItemItem
 */
export class SalesPerItemItem extends Message<SalesPerItemItem> {
  /**
   * Unique identifier for the batch
   *
   * @generated from field: string batch_id = 1;
   */
  batchId = "";

  /**
   * Trade name of the product
   *
   * @generated from field: string trade_name = 2;
   */
  tradeName = "";

  /**
   * Batch number of the product
   *
   * @generated from field: string batch_number = 3;
   */
  batchNumber = "";

  /**
   * Expiry date of the batch
   *
   * @generated from field: google.protobuf.Timestamp expiry_date = 4;
   */
  expiryDate?: Timestamp;

  /**
   * Unit of measurement for the product (e.g., pieces, grams, etc.)
   *
   * @generated from field: int32 unit = 5;
   */
  unit = 0;

  /**
   * Type of unit for the product (e.g.,
   *
   * @generated from field: string unit_type = 6;
   */
  unitType = "";

  /**
   * Actual quantity received in the batch
   *
   * @generated from field: float actual_quantity_received = 7;
   */
  actualQuantityReceived = 0;

  /**
   * Quantity sold or consumed from the batch
   *
   * @generated from field: float sold_consumed_quantity = 8;
   */
  soldConsumedQuantity = 0;

  /**
   * Quantity available in the batch
   *
   * @generated from field: float available_quantity = 9;
   */
  availableQuantity = 0;

  /**
   * Date when the batch was last sold
   *
   * @generated from field: google.protobuf.Timestamp last_sold_date = 10;
   */
  lastSoldDate?: Timestamp;

  /**
   * Latest selling price of the product
   *
   * @generated from field: float latest_selling_price = 11;
   */
  latestSellingPrice = 0;

  /**
   * Cost price of the product
   *
   * @generated from field: float cost_price = 12;
   */
  costPrice = 0;

  /**
   * Total revenue generated at the latest selling price
   *
   * @generated from field: float total_revenue_at_latest_selling_price = 13;
   */
  totalRevenueAtLatestSellingPrice = 0;

  /**
   * Total cost of goods sold for the batch
   *
   * @generated from field: float total_cost_of_goods_sold = 14;
   */
  totalCostOfGoodsSold = 0;

  /**
   * Gross profit calculated as (total revenue - total COGS)
   *
   * @generated from field: float gross_profit = 15;
   */
  grossProfit = 0;

  /**
   * Gross margin percentage calculated as (gross
   *
   * @generated from field: float gross_margin_percentage = 16;
   */
  grossMarginPercentage = 0;

  constructor(data?: PartialMessage<SalesPerItemItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SalesPerItemItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "batch_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "batch_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "expiry_date", kind: "message", T: Timestamp },
    { no: 5, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "actual_quantity_received", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "sold_consumed_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "available_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "last_sold_date", kind: "message", T: Timestamp },
    { no: 11, name: "latest_selling_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 12, name: "cost_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 13, name: "total_revenue_at_latest_selling_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 14, name: "total_cost_of_goods_sold", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 15, name: "gross_profit", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 16, name: "gross_margin_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SalesPerItemItem {
    return new SalesPerItemItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SalesPerItemItem {
    return new SalesPerItemItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SalesPerItemItem {
    return new SalesPerItemItem().fromJsonString(jsonString, options);
  }

  static equals(a: SalesPerItemItem | PlainMessage<SalesPerItemItem> | undefined, b: SalesPerItemItem | PlainMessage<SalesPerItemItem> | undefined): boolean {
    return proto3.util.equals(SalesPerItemItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.MovingItemsItem
 */
export class MovingItemsItem extends Message<MovingItemsItem> {
  /**
   * Unique identifier for the product master
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * Type of item (e.g., medical, non-medical)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 2;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * Trade name of the product
   *
   * @generated from field: string trade_name = 3;
   */
  tradeName = "";

  /**
   * Total sales of the product in the last 90 days
   *
   * @generated from field: float total_sales_last_90_days = 4;
   */
  totalSalesLast90Days = 0;

  /**
   * Total sales of the product in the last 60 days
   *
   * @generated from field: float total_sales_last_60_days = 5;
   */
  totalSalesLast60Days = 0;

  /**
   * Total sales of the product in the last 30 days
   *
   * @generated from field: float total_sales_last_30_days = 6;
   */
  totalSalesLast30Days = 0;

  /**
   * Average sales of the product in the last 90 days
   *
   * @generated from field: float average_sales_last_90_days = 7;
   */
  averageSalesLast90Days = 0;

  /**
   * Average sales of the product in the last 60 days
   *
   * @generated from field: float average_sales_last_60_days = 8;
   */
  averageSalesLast60Days = 0;

  /**
   * Average sales of the product in the last 30 days
   *
   * @generated from field: float average_sales_last_30_days = 9;
   */
  averageSalesLast30Days = 0;

  /**
   * Days of supply remaining for the product
   *
   * @generated from field: float days_of_supply_remaining = 10;
   */
  daysOfSupplyRemaining = 0;

  constructor(data?: PartialMessage<MovingItemsItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MovingItemsItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 3, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total_sales_last_90_days", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "total_sales_last_60_days", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "total_sales_last_30_days", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "average_sales_last_90_days", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "average_sales_last_60_days", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "average_sales_last_30_days", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "days_of_supply_remaining", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MovingItemsItem {
    return new MovingItemsItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MovingItemsItem {
    return new MovingItemsItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MovingItemsItem {
    return new MovingItemsItem().fromJsonString(jsonString, options);
  }

  static equals(a: MovingItemsItem | PlainMessage<MovingItemsItem> | undefined, b: MovingItemsItem | PlainMessage<MovingItemsItem> | undefined): boolean {
    return proto3.util.equals(MovingItemsItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ItemsToReorderItem
 */
export class ItemsToReorderItem extends Message<ItemsToReorderItem> {
  /**
   * Unique identifier for the product master
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * Type of item (e.g., medical, non-medical)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 2;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * Trade name of the product
   *
   * @generated from field: string trade_name = 3;
   */
  tradeName = "";

  /**
   * Current total quantity of the product in stock
   *
   * @generated from field: float current_total_quantity = 4;
   */
  currentTotalQuantity = 0;

  /**
   * Reorder point quantity for the product
   *
   * @generated from field: float reorder_point_quantity = 5;
   */
  reorderPointQuantity = 0;

  /**
   * Maximum stock quantity for the product
   *
   * @generated from field: float maximum_stock_quantity = 6;
   */
  maximumStockQuantity = 0;

  /**
   * Suggested reorder quantity for the product
   *
   * @generated from field: float suggested_reorder_quantity = 7;
   */
  suggestedReorderQuantity = 0;

  /**
   * Average sales of the product in the last 60 days
   *
   * @generated from field: float average_sales_last_60_days = 8;
   */
  averageSalesLast60Days = 0;

  constructor(data?: PartialMessage<ItemsToReorderItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ItemsToReorderItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 3, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "current_total_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "reorder_point_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "maximum_stock_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "suggested_reorder_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "average_sales_last_60_days", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ItemsToReorderItem {
    return new ItemsToReorderItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ItemsToReorderItem {
    return new ItemsToReorderItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ItemsToReorderItem {
    return new ItemsToReorderItem().fromJsonString(jsonString, options);
  }

  static equals(a: ItemsToReorderItem | PlainMessage<ItemsToReorderItem> | undefined, b: ItemsToReorderItem | PlainMessage<ItemsToReorderItem> | undefined): boolean {
    return proto3.util.equals(ItemsToReorderItem, a, b);
  }
}

